export default __webpack_public_path__ + "static/media/Fruits.1742c978.jpg";